var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBedDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C3.5 0 3 0.21 2.61 0.6C2.22 0.99 2 1.45 2 2V5C1.47 5 1 5.19 0.59 5.59C0.18 5.99 0 6.47 0 7V12H1.34L2 14H3L3.69 12H12.36L13 14H14L14.66 12H16V7C16 6.47 15.81 6 15.41 5.59C15.01 5.18 14.53 5 14 5V2C14 1.45 13.8 1 13.39 0.6C12.98 0.2 12.5 0 12 0H4ZM4 2H7V5H4V2ZM9 2H12V5H9V2ZM2 7H14V10H2V7Z",
    fill: "#848585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedDouble);
export default __webpack_public_path__ + "static/media/bed-double.5ecdac4780c2449e0d36468e43f76979.svg";
export { ForwardRef as ReactComponent };